module.exports = __webpack_public_path__ + "static/media/YM21_0.fa3b147e.jpg";